// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DebitItem from '@deere/cps-it.warranty-model-factory/lib/partial-debit';
import EditableField from '../../../../shared/components/editable-field';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';
import KeyValueDropDown from '../../../../claim/shared/components/claim-fields/key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {getAmountWithCurrency} from '../../services/partial-debit-helper';

function handleAdjustmentValueChange(value) {

    this.onAdjustmentValueChange(value);

}

function handleAdjustmentTypeChange(event) {

    this.onAdjustmentTypeChange(event.target.value);

}

function filterAdjustmentTypes(adjustmentTypes, material) {

    // other credits adjustment type should exclude quantity, unless they are loaner hours

    const keyToExclude = material === 'WTYSUBL11' ? '03' : '02';

    return adjustmentTypes && adjustmentTypes.filter(adjustmentType => adjustmentType.key !== keyToExclude);

}

const DebitOtherCreditPanelRowBody = props =>
    <section className='debit-other-credit-panel-row-body'>
        <span className='description'>{props.credit.description}</span>
        <span className='quantity'>{props.credit.quantity}</span>
        <span className='amount'>{getAmountWithCurrency(props.credit.amount, props.credit.currency)}</span>
        <EditableField
            className='adjustment-type'
            isEditable={props.isEditable}
            value={props.credit.adjustmentType.value}
        >
            <KeyValueDropDown
                className='adjustment-type'
                list={filterAdjustmentTypes(props.adjustmentTypes, props.credit.material)}
                onChange={props::handleAdjustmentTypeChange}
                showBlankOption={false}
                value={props.credit.adjustmentType.key}
            />
        </EditableField>
        <EditableField
            className='value-of-adjustment'
            isEditable={props.isEditable && props.credit.adjustmentType.key !== '01'}
            value={props.credit.adjustmentType.key === 'AMOUNT' ? getAmountWithCurrency(props.credit.valueOfAdjustment, props.credit.currency) : props.credit.valueOfAdjustment}
        >
            <FormattedNumberInput
                allowNegative={false}
                className='value-of-adjustment'
                decimalPrecision={2}
                onValueChange={props::handleAdjustmentValueChange}
                value={props.credit.valueOfAdjustment}
            />
        </EditableField>
    </section>;

DebitOtherCreditPanelRowBody.displayName = 'DebitOtherCreditPanelRowBody';
DebitOtherCreditPanelRowBody.propTypes = {
    adjustmentTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    credit: PropTypes.instanceOf(DebitItem).isRequired,
    isEditable: PropTypes.bool.isRequired,
    onAdjustmentTypeChange: PropTypes.func,
    onAdjustmentValueChange: PropTypes.func
};

export default DebitOtherCreditPanelRowBody;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-other-credits-panel/debit-other-credit-panel-row-body.js